import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
    return (
        <section className="hero">
            <div className="hero-background">
                <div className="hero-shapes">
                    <div className="shape shape-1"></div>
                    <div className="shape shape-2"></div>
                    <div className="shape shape-3"></div>
                    <div className="shape-blue shape-blue-1"></div>
                    <div className="shape-blue shape-blue-2"></div>
                    <div className="shape-blue shape-blue-3"></div>
                </div>
            </div>

            <div className="container">
                <div className="hero-content">
                    <div className="hero-text">
                        <h1 className="hero-title">
                            Avenis is your new avenue<br></br>
                            <span className="highlight">
                                to smarter selling
                            </span>
                        </h1>
                        <p className="hero-description">
                            Discover smarter selling through authorized retail
                            partnerships. With 100% MAP compliance, brand-safe
                            content, and full transparency, Avenis opens your
                            avenue to e-commerce performance at its best.
                        </p>
                        <div className="hero-actions">
                            <Link
                                to="/contact"
                                className="btn btn-primary"
                                onClick={() => window.scrollTo(0, 0)}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
                                </svg>
                                Get Started
                            </Link>
                            <Link
                                to="/services"
                                className="btn btn-secondary"
                                onClick={() => window.scrollTo(0, 0)}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <path d="M12 6v6l4 2"></path>
                                </svg>
                                Explore Services
                            </Link>
                        </div>
                    </div>
                    <div className="hero-image">
                        <div className="hero-dashboard">
                            <div className="dashboard-header">
                                <div className="compliance-score">
                                    <div className="score-label">
                                        Compliance Score
                                    </div>
                                    <div className="score-value">100%</div>
                                </div>
                                <div className="map-protected">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    <span>MAP Protected</span>
                                </div>
                            </div>

                            <div className="dashboard-stats-enhanced">
                                <div className="stat-card-enhanced">
                                    <div className="stat-icon stat-icon-1">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                            <circle
                                                cx="9"
                                                cy="7"
                                                r="4"
                                            ></circle>
                                            <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                                            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                        </svg>
                                    </div>
                                    <div className="stat-content">
                                        <h3 className="stat-number">40+</h3>
                                        <p className="stat-label">
                                            Premium Brands
                                        </p>
                                        <div className="stat-trend">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="10"
                                                height="10"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M3 3v18h18"></path>
                                                <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
                                            </svg>
                                            <span>+12%</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="stat-card-enhanced">
                                    <div className="stat-icon stat-icon-2">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M9 12l2 2 4-4"></path>
                                            <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.5 0 2.91.37 4.15 1.02"></path>
                                            <path d="M16 2l4 4-4 4"></path>
                                        </svg>
                                    </div>
                                    <div className="stat-content">
                                        <h3 className="stat-number">0</h3>
                                        <p className="stat-label">
                                            MAP Violations
                                        </p>
                                        <div className="stat-trend">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="10"
                                                height="10"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M9 12l2 2 4-4"></path>
                                                <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.5 0 2.91.37 4.15 1.02"></path>
                                                <path d="M16 2l4 4-4 4"></path>
                                            </svg>
                                            <span>Perfect Score</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="stat-card-enhanced">
                                    <div className="stat-icon stat-icon-3">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M9 11H5a2 2 0 0 0-2 2v3c0 1.1.9 2 2 2h4"></path>
                                            <path d="M15 11h4a2 2 0 0 1 2 2v3c0 1.1-.9 2-2 2h-4"></path>
                                            <path d="M9 7h6v4H9z"></path>
                                            <path d="M9 3h6v4H9z"></path>
                                        </svg>
                                    </div>
                                    <div className="stat-content">
                                        <h3 className="stat-number">500+</h3>
                                        <p className="stat-label">Projects</p>
                                        <div className="stat-trend">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="10"
                                                height="10"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M3 3v18h18"></path>
                                                <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
                                            </svg>
                                            <span>+25%</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="stat-card-enhanced">
                                    <div className="stat-icon stat-icon-4">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                                            <path d="M2 17l10 5 10-5"></path>
                                            <path d="M2 12l10 5 10-5"></path>
                                        </svg>
                                    </div>
                                    <div className="stat-content">
                                        <h3 className="stat-number">
                                            {new Date().getFullYear() - 2018}+
                                        </h3>
                                        <p className="stat-label">
                                            Years Experience
                                        </p>
                                        <div className="stat-trend">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="10"
                                                height="10"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M9 12l2 2 4-4"></path>
                                                <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.5 0 2.91.37 4.15 1.02"></path>
                                                <path d="M16 2l4 4-4 4"></path>
                                            </svg>
                                            <span>Since 2018</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
